
export type GetUserStats200BadgesItem = {
  description?: string;
  earnedAt?: string;
  id?: string;
  imageUrl?: string;
  name?: string;
};
